export const Step = {
  INICIO: 1,
  CADASTRO_RESERVA_AGENDADA: 8,
  CADASTRO_RESERVA_APROVADA: 11,
  CADASTRO_RESERVA_CANCELADA: 12,
  CADASTRO_RESERVA_REAGENDADA: 13,
  SELECAO_CONTRATANTE_CONFIRMADA: 18,
  CADASTRO_CONTRATADO: 25,
  CADASTRO_CONTRATADO_INCLUSAO: 33,
  CADASTRO_CONTRATADO_EXCLUSAO: 35
};

export default {
  Step
};



// WEBPACK FOOTER //
// ./src/modules/guiaInterativo/constants.js